import { axios } from '@repo/http';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { get_people_ud_path } from 'ze-api-contract/people-v2/crud-people';
import { orgPeopleList } from '../organization-people-list';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useDeletePeople() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (param)=>{
            let { organizationId, peopleId } = param;
            return axios.delete(get_people_ud_path({
                organization: organizationId,
                id: peopleId
            }));
        },
        onSuccess: async (res, param)=>{
            let { organizationId } = param;
            await queryClient.invalidateQueries({
                queryKey: [
                    orgPeopleList.peopleList({
                        organization: organizationId
                    }).queryKey[0]
                ]
            });
        }
    });
}
